/**
 * The avatar-menu label for the analytics / earnings entry.
 *
 * The creator EARNINGS (referral) programme is SUSPENDED (Gordon, 2026-07-24:
 * "The Earnings Portal popup should not be showing up for now - we suspended
 * the earnings program"). While it is suspended this entry reads "Analytics"
 * for every user, INCLUDING users still flagged as members of the programme —
 * membership is untouched, only the marketing of it is withheld.
 *
 * Extracted from the JSX so the rule can be asserted directly in BOTH flag
 * directions: that the suspension hides the label today, and that flipping the
 * flag back restores it, so the hide can never silently rot into a delete.
 */
export const EARNINGS_LABEL = "Earnings Portal";
export const ANALYTICS_LABEL = "Analytics";

export function earningsMenuLabel({ suspended, isInReferralProgram }) {
  return !suspended && isInReferralProgram ? EARNINGS_LABEL : ANALYTICS_LABEL;
}

export default earningsMenuLabel;
